import React from "react"
import { Box } from "rebass"

import Button from "../buttons"

const Buttons = props => {
  const { data } = props

  const scrollTo = (event, id) => {
    event.preventDefault()
    let target = document.querySelector(id)
    if (target) target.scrollIntoView({ behavior: "smooth" })
  }

  const isHash = url => {
    return url.search(`#`) >= 0
  }

  return (
    <Box as="nav" {...props}>
      {data.map((button, index, array) => (
        <Button
          key={index}
          href={button.url}
          variant={button.btnVariant}
          ml={[0, index === 0 ? 0 : 3]}
          mr={[0, index >= array.length - 1 ? 0 : 3]}
          sx={{
            "@media (max-width: 767px)": {
              display: button.hideOnMobile && "none",
            },
          }}
          onClick={e => (isHash(button.url) ? scrollTo(e, button.url) : null)}
        >
          {button.label}
        </Button>
      ))}
    </Box>
  )
}

export default Buttons
